import {
    AfterViewInit,
    ChangeDetectorRef,
    Directive,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener, Inject, Injector,
    Input, LOCALE_ID,
    OnChanges, OnInit, Optional, Output, Self
} from '@angular/core';
import {
    FormArray,
    ControlValueAccessor,
    FormControl, NgForm, FormGroupDirective, NgControl, NG_VALUE_ACCESSOR, NgModel
} from '@angular/forms';
import { ValueAccessor } from './value-accessor';
import { TIME_MERIDIEM } from '../interfaces/Tokens';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-list'
})
export class ListValueDirective implements AfterViewInit, ControlValueAccessor, OnChanges {
    private _list;
    private readonly parent: NgForm | FormGroupDirective | null;

    public value: string[];

    get parsedField() {
        return (this.field) ? this.field.parsedList : undefined;
    }

    get list() {
        if (!this._list) {
            this.list = this._element.nativeElement;
        }
        return this._list;
    }
    set list(el) {
        this._list = el;
    }

    @Input() ngModel: NgModel;
    @Input() public control: any;
    @Input() public field: any;

    @Output() public readonly valueChange: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('anjBlur')
    onAnjBlur() {
        this.onTouch();
    }

    @HostListener('anjChange', ['$event.target'])
    public onAnjChange(target: HTMLInputElement) {

        if (!target.matches('anj-list')) {
            return;
        }

        this.changeHandler(target.value.slice(0));
    }

    @HostBinding('attr.invalid') get isInvalid(): boolean {
        if (this.ngControl) {
            const isSubmitted = (this.parent && this.parent.submitted);
            return (this.ngControl.invalid && (this.ngControl.touched || isSubmitted));
        }

        if (this.control) {
            return this.control.invalid;
        }
    }

    constructor(private _element: ElementRef,
                private changeRef: ChangeDetectorRef,
                @Optional() parentForm: NgForm,
                @Optional() parentGroup: FormGroupDirective,
                @Optional() @Self() private ngControl?: NgControl) {
        this.parent = parentForm ? parentForm : parentGroup ? parentGroup : null;

        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngAfterViewInit() {
        if ((this.ngControl && this.ngControl.value) || this.ngModel) {
            this.value = this.ngModel || this.ngControl.value;
            this.list.value = this.value;

            this.changeRef.detectChanges();
        }
    }

    ngOnChanges() {
        this.setAttributes();

        if (this.control && this.control.value) {
            this.value = this.control.value;
            this.list.value = this.value;

            this.changeRef.detectChanges();
        }
    }

    setAttributes() {
        if (this.field) {
            this.list.setAttribute('min', this.field.minItems || this.list.min);
            this.list.setAttribute('max', this.field.maxItems || this.list.max);
        }

        if (this.parsedField) {
            this.list.setAttribute('options', this.parsedField.options || this.list.options);
            this.list.setAttribute('type', this.parsedField.toInputType() || this.list.type);
        }
    }

    // Start: ControlValueAccessor requirements
    public writeValue(newValue: any): void {
        this.value = newValue;
        this.list.value = this.value;
    }

    public onChange: (value: any) => void = () => {/**/};
    public onTouch: () => void = () => {/**/};

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
    // End: ControlValueAccessor requirements

    private changeHandler(changedVal): void {
        this.onTouch();
        this.value = changedVal;

        this.valueChange.emit(this.value);
        this.propogateValueChange();
    }

    private propogateValueChange(): void {
        if (this.ngControl) {
            this.ngControl.control.patchValue(this.value);
        } else if (this.control) {
            this.control.controls = [];
            this.value.map(value =>
                this.control.push(new FormControl(value))
            );
        }

        this.changeRef.detectChanges();
    }
}
